import React, { useMemo, useRef } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import moment from 'moment';
import { ObjectOfStringValue } from '@/pages/aigc/hooks/useQuery';
import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';
import { stringToFunction } from '@/pages/dashboard/utils/stringToJson';

export default function PcConsoleMonetizationRevenueTrendCo(props: any) {
  const { style, className, config, children, ...resetProps } = props || {};
  const {
    api,
    isSingle = true,
    dataKey,
    isSegmentFilter,
    breakDownType,
    serviceParams: restApiConfig,
    beforeRequest: configBeforeRequest,
  } = config || {};
  const { gameCode } = useSelector(
    (state: any) => ({
      gameCode: state?.dashboard?.currentGame?.game_code,
    }),
    shallowEqual,
  );

  const data = useMemo(
    () => ({
      gameCode,
      regionDataType: props?.data?.regionDataType,
    }),
    [gameCode, props?.data?.regionDataType],
  );

  // 请求版本号，用于解决快速切换 tab 时的竞态问题（同 SalesBreakdownCardService / PlatformMetricsCo）
  const requestVersionRef = useRef<number>(0);

  const apiRequest = (params: any) => {
    requestVersionRef.current += 1;
    const currentVersion = requestVersionRef.current;

    return dashboardRequest({
      url: api,
      method: 'post',
      data: params,
    })
      .then((resData: unknown) => {
        if (currentVersion !== requestVersionRef.current) {
          return new Promise(() => {});
        }
        return resData;
      })
      .catch((e: unknown) => {
        if (currentVersion !== requestVersionRef.current) {
          return new Promise(() => {});
        }
        return Promise.reject(e);
      });
  };

  return (
    <div className={className} style={style}>
      <Service
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        api={apiRequest}
        data={data}
        dataKey={dataKey}
        beforeRequest={data => {
          const { filterVal, regionDataType } = data;
          const { timeType, rangeTime, ...filters } = filterVal;
          const tabNames: ObjectOfStringValue = {
            Day: 'daily',
            Week: 'weekly',
            Month: 'monthly',
          };
          let params: { [key in string]: unknown } = {
            game_code: gameCode,
            start_time: moment(rangeTime?.[0]).format('YYYY-MM-DD'),
            end_time: moment(rangeTime?.[1]).format('YYYY-MM-DD'),
            period: tabNames[timeType] || 'daily',
            filters: formatFilterValues(filters),
            ...restApiConfig,
          };
          if (isSegmentFilter) {
            params.by_type = breakDownType;
            params.metric = regionDataType || 'mtx_revenue';
          }
          if (configBeforeRequest) {
            const handler =
              typeof configBeforeRequest === 'string'
                ? stringToFunction(configBeforeRequest)
                : configBeforeRequest;
            params = handler(data, params) ?? params;
          }
          return params;
        }}
        trackData={['gameCode', 'regionDataType']}
      >
        {React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...resetProps,
            isSingle,
            state: {
              regionDataType: props?.data?.regionDataType,
              breakDownType,
            },
          }),
        )}
      </Service>
    </div>
  );
}
